import { Box, SxProps, Theme } from '@mui/material';

const containerStyles: SxProps<Theme> = {
  background: 'url(403.png) no-repeat center center fixed',
  WebkitBackgroundSize: 'cover',
  MozBackgroundSize: 'cover',
  OBackgroundSize: 'cover',
  backgroundSize: 'cover',
  height: '100%',
  marginLeft: '-3.5%',
  marginRight: '-3.5%',
};

export const Unauthorized = () => {
  return <Box sx={containerStyles}></Box>;
};
